// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__FV0vO","inner":"Form_inner__2e3vi","range":"Form_range__2ozvk","name":"Form_name__3NdDE","actions":"Form_actions__3r2Lh"};